export const AreaSegmentOptions = Object.freeze({
    Shop: "shop",
    Brands: "brands",
    Promotions: "promotions",
})
